Vue.component('chargebee-payments', {
	props: ['payment_plan', 'is_custom', 'team', 'is_subscribed', 'addons', 'coupons'],
	data() {
		return {
			plan: 'monthly',
			message: '',
			isLoading: false
		}
	},
	computed: {
		monthlyPlan() {

			return this.payment_plan

		},
		yearlyPlan() {
			return this.payment_plan + '-yearly'
		},
		currentPlan() {

			if (this.plan == 'yearly') {
				return this.yearlyPlan
			} else {
				return this.monthlyPlan
			}

		},
		subscribedText() {
			if (this.coupons.length > 0 || this.is_custom) {
				return 'See Details'
			} else {
				return 'Subscribe'
			}
		}
	},
	mounted() {
		// window.Chargebee.registerAgain()
	},
	methods: {
		requestQuote() {
			this.isLoading = true
			axios.post('/api/teams/' + this.team.id + '/request-quote')
			.then(response => {
				this.message = 'Thank you for your interest! Our team will get back to you with a quote within 24 hours.'
				this.isLoading = false
			}).catch(error => {
				this.isLoading = false
			})
		},
		subscribe() {

			// Boilerplate setting up for chargebee
			var cbInstance = window.Chargebee.getInstance();
			var cart = cbInstance.getCart();
			var customer = {};
			var product = cbInstance.initializeProduct(this.currentPlan);

			// Set team and user data as custom fields to use later
			let data = {cf_team: this.team.id, cf_user: Spark.state.user.id}
			product.setCustomData(data)

			// Add addons
			for (addon of this.addons) {
				product.addAddon({id: addon.addon_id, quantity: addon.quantity})
			}

			// Apply coupons
			for (coupon of this.coupons) {
				product.addCoupon(coupon.coupon_id)
			}

			console.log(product.data)

			// Add product to payload
			cart.replaceProduct(product)

			// Everything ready, let's check out
			cart.proceedToCheckout()
		}
	}
});